import { IMicrofrontendsAPI } from '../../../shared/types/microfrontends/types';
import { getDesktopFiltersMicrofrontendAPI } from '../getDesktopMicrofrontendApi/getDesktopMicrofrontendApi';
import { getSearchStringMicrofrontendAPI } from '../getSearchStringMicrofrontendApi/getSearchStringMicrofrontendApi';

export function createMicrofrontendsAPI(): IMicrofrontendsAPI {
  return {
    getDesktopFiltersMicrofrontendAPI: () => getDesktopFiltersMicrofrontendAPI(),
    getSearchStringMicrofrontendAPI: () => getSearchStringMicrofrontendAPI(),
  };
}
